export class InvalidDocumentError extends Error {
  constructor(public readonly documentType: string, message?: string) {
    super(message ?? `Invalid document type ${documentType}.`);
    Object.setPrototypeOf(this, InvalidDocumentError.prototype);
  }
}
